export const sanitizeRateShoppingLogicItem = (item) => {
    const clean = {
        Mapping: item.Mapping,
        Logic: item.Logic,
    };
    if ('Markup' in item) {
        clean.Markup = item.Markup === true || item.Markup === 'true';
    }
    return clean;
};

export const sanitizeRateShoppingLogic = (items) => {
    if (!Array.isArray(items)) {
        return [];
    }
    return items.map(sanitizeRateShoppingLogicItem);
};

export const getRateShoppingGridColumns = () => {

    var translate = window.translate;
    return ({
        columns: [
            {
                field: "Mapping",
                title: translate("Label_Ship_Service_Keyword"),
            },
            {
                field: "Logic",
                title: translate("Label_Rate_Type")
            },
            {
                field: "Markup",
                title: translate("Label_Select_By"),
                template: function (dataItem) {
                    let selectBy = "";
                    if (!!dataItem?.Markup) {
                        selectBy = JSON.parse(dataItem.Markup) ? "Rate + markup" : "Rate";
                    }
                    else {
                        selectBy = "Rate";
                    }
                    return selectBy;
                }
            }, {
                field: 'cmdRemove',
                menu: false,
                command: [{
                    name: "destroy",
                    text: " ",
                    className: "rate-shop-delete",
                    iconClass: "fa fa-trash"
                }],
                title: "&nbsp;",
                width: 32,
            }
        ]
    });
};

export const getRateShoppingGridSchema = () => {
    return ({
        schema: {
            model: {
                fields: {
                    Mapping: {
                        type: "string",
                        editable: false
                    },
                    Logic: {
                        type: "string",
                        editable: false
                    },
                    Markup: {
                        type: "string",
                        editable: false
                    }
                }
            }
        }
    });
};
export const getCarrierMarkUpSettingsSchema = () => {
    return ({
        model: {
            fields: {
                Carrier: {
                    type: "string",
                    editable: false
                },
                AccountNumber: {
                    type: "string",
                    editable: false
                },
                Owner: {
                    type: "string",
                    editable: false
                },
                Allocated: {
                    type: "string",
                    editable: false
                }
            }
        }
    })
}

